import { CURRENCIES, type CurrencyCode } from '../types';

const localeMap: Record<CurrencyCode, string> = {
  ARS: 'es-AR',
  USD: 'en-US',
  EUR: 'de-DE',
  BRL: 'pt-BR',
  CLP: 'es-CL',
  MXN: 'es-MX',
  UYU: 'es-UY',
};

export function formatCurrency(cents: number, currencyCode: CurrencyCode): string {
  const locale = localeMap[currencyCode] || 'en-US';
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currencyCode,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(cents / 100);
}

export function parseCurrencyInput(value: string): number {
  // Remove all non-numeric characters except decimal separators
  const cleaned = value.replace(/[^\d.,]/g, '');
  // Handle both comma and dot as decimal separator
  const normalized = cleaned.replace(',', '.');
  const parsed = parseFloat(normalized);
  // Convert to cents and round
  return isNaN(parsed) ? 0 : Math.round(parsed * 100);
}

export function centsToDollars(cents: number): string {
  return (cents / 100).toFixed(2);
}

export function getCurrencySymbol(currencyCode: CurrencyCode): string {
  const currency = CURRENCIES.find((c) => c.code === currencyCode);
  return currency?.symbol || '$';
}
